import { Schema } from "effect";
import { DarkquellOutput } from "./Darkquell.js";
import { MeetingSummary } from "./MeetingSummary.js";
import { BatchPredictionResponse } from "./SkillClassifier.js";
export const ModelOutput = Schema.Struct({
    darkquell: Schema.optional(DarkquellOutput),
    meetingSummary: Schema.optional(MeetingSummary),
    skillclassifier: Schema.optional(BatchPredictionResponse),
});
